export default "__VITE_ASSET__MAvb9xdF__"